import React from 'react';
import Textarea from 'components/styleguide/textarea/Textarea';
import { useCurationReview } from './state/CurationReviewContext';

const styles = require('./RecruiterNotes.module.scss');

// Free-text notes sent with the decision. Shared with the employer after
// approval through the existing screening-notes path; never shown to the
// candidate.
export default function RecruiterNotes() {
  const { dispatch, state } = useCurationReview();

  return (
    <div className={styles['ui-recruiter-notes']}>
      <label className={styles['ui-recruiter-notes__label']} htmlFor="curation-recruiter-notes">
        Recruiter notes
      </label>
      <Textarea
        disabled={state.submitted}
        hint="Visible to the employer after approval. Not visible to the candidate."
        id="curation-recruiter-notes"
        onChange={(event) => dispatch({ type: 'SET_NOTES', value: event.target.value })}
        rows={5}
      />
    </div>
  );
}
